module.exports = __webpack_public_path__ + "img/img_receipt_complete_noproduct.png";